<template>
  <wiskModal :visible="!!editAction" @hide="setGlobalAction({ type: 'orderGuideLists', action: null })"
    class="" size="md" hideOK hideFooter hideHeaderExtra>
    <template v-slot:modal-title>
      <b-row>
        <b-col cols="4">
          <h5 class="modal-title"> {{ translations.txtOrderGuideLists }} </h5>
        </b-col>
        <b-col cols="4">
          <wiskInput infoTooltipKey="9509fccc-20e4-40cc-8666-a019b82af9f2" :label="translations.txtServingSizesShowArchived" v-model="showArchived" inputType="checkbox" class="" />
        </b-col>
        <b-col cols="4">
          <b-button v-if="canManage" @click="addOrderGuideList" size="sm" class="float-end me-2" variant="primary"> {{ translations.txtOrderGuideListsNew }} </b-button>
        </b-col>
      </b-row>
    </template>

    <b-container style="min-height: 400px;">
      <p class="text-muted small mt-2">{{ translations.txtOrderGuideListsDefaultInfo }}</p>

      <b-row v-for="orderGuideList in localOrderGuideLists" :key="orderGuideList.id" class="order-guide-list" :class="{ 'bg-warning': orderGuideList.archived }">
        <b-col cols="7">
          {{ orderGuideListDisplayTitle(orderGuideList) }} {{ orderGuideList.archived ? ` - (${translations.txtGenericArchived})` : '' }}
          <b-badge v-if="orderGuideList.is_default" variant="info" class="ms-2">{{ translations.txtOrderGuideListsDefault }}</b-badge>
          <span class="text-muted small ms-2">({{ itemsCountByListId[orderGuideList.id] || 0 }})</span>
        </b-col>
        <b-col v-if="canManage" class="px-1">
          <b-button variant="link" @click="openEdit(orderGuideList)" class="py-0 order-guide-list-edit-action" v-tooltip="translations.txtGenericEdit">
            <icon name="wisk-edit" class="text-primary" :scale="0.8" />
          </b-button>
        </b-col>
        <b-col v-if="canManage" class="px-1">
          <b-button v-if="!orderGuideList.is_default && !orderGuideList.archived" variant="link" @click="onChange(orderGuideList, { type: 'set_default' })" class="py-0 order-guide-list-edit-action"
            v-tooltip="translations.txtOrderGuideListsSetDefault">
            <icon name="wisk-check" class="text-success" :scale="0.8" />
          </b-button>
        </b-col>
        <b-col v-if="canManage" class="px-1">
          <b-button v-if="orderGuideList.archived" variant="link" @click="onChange(orderGuideList, { type: 'archive', value: false })" class="py-0 order-guide-list-edit-action"
            v-tooltip="translations.txtGenericRestore">
            <icon name="wisk-history" class="text-success" :scale="0.8" />
          </b-button>
          <!-- The default order guide can't be archived: another one has to be set as default first -->
          <b-button v-if="!orderGuideList.archived && !orderGuideList.is_default" variant="link" @click="onChange(orderGuideList, { type: 'archive', value: true })" class="py-0 order-guide-list-edit-action"
            v-tooltip="translations.txtGenericArchive">
            <icon name="wisk-archive" class="text-danger" :scale="0.8" />
          </b-button>
        </b-col>
      </b-row>
    </b-container>

    <confirm ref="confirmDialog" autofocus />

  </wiskModal>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import api from '@/api'

export default {
  name: 'OrderGuideListsEdit',
  components: {},
  props: {
    editAction: {
      type: Object
    }
  },
  data() {
    return {
      showArchived: false,
      localOrderGuideLists: []
    }
  },
  computed: {
    ...mapGetters(['orderGuideVariantIdsByListId', 'orderGuideListDisplayTitle']),
    ...mapState(['translations', 'orderGuideLists', 'currentPermissionsByType']),
    canManage() {
      return !!this.currentPermissionsByType.item_manage
    },
    itemsCountByListId() {
      let result = {}
      Object.keys(this.orderGuideVariantIdsByListId).forEach(listId => {
        result[listId] = Object.keys(this.orderGuideVariantIdsByListId[listId] || {}).length
      })
      return result
    }
  },
  methods: {
    ...mapActions(['setGlobalAction']),
    addOrderGuideList() {
      this.openEdit({ title: '', id: 0 })
    },
    openEdit(orderGuideList) {
      if (this.$refs.confirmDialog) {
        this.$refs.confirmDialog.prompt({
          callback: value => {
            this.onChange(orderGuideList, { type: 'title', value })
          },
          text: this.orderGuideListDisplayTitle(orderGuideList),
          required: true,
          message: this.translations.txtGenericTitle,
          title: orderGuideList.id ? this.translations.txtOrderGuideListsTitle : this.translations.txtOrderGuideListsNew
        })
      }
    },
    onChange(orderGuideList, operation) {
      api.updateOrderGuideList(orderGuideList.id, operation).then(result => {
        if (typeof this.editAction?.onChange === 'function') {
          this.editAction.onChange(result)
        }
      })
    },
    load() {
      this.localOrderGuideLists = this.orderGuideLists
        .map(l => ({ ...l }))
        .filter(l => this.showArchived || !l.archived)
        .sort((a, b) => (a.is_default === b.is_default ? this.orderGuideListDisplayTitle(a).localeCompare(this.orderGuideListDisplayTitle(b)) : a.is_default ? -1 : 1))
    }
  },
  watch: {
    orderGuideLists: {
      immediate: true,
      handler: 'load'
    },
    showArchived: 'load'
  }
}
</script>

<style lang="scss">
.order-guide-list {
  border-radius: 4px;
  margin-top: 5px;
  height: 30px;
  line-height: 2rem;

  &:nth-child(even) {
    background-color: rgba(28, 130, 239, 0.1);
  }

  &:hover {
    background-color: rgba(59, 195, 59, 0.2);

    .order-guide-list-edit-action {
      opacity: 1;
    }
  }

  .order-guide-list-edit-action {
    opacity: 0;
  }
}
</style>
